import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Home from './app/page';
import ContactUs from './app/contactus';
import AboutUs from './app/aboutus';
import DoctorList from './app/doctorlist';
import PrivacyPolicy from './app/privacypolicy';
import TermsAndConditions from './app/termsandconditions';
import Login from './app/login/page';
import DoctorDashboard from './app/dashboard/doctor/page';
import DoctorProfile from './app/dashboard/doctor/profile/page';
import FeesPaymentMethod from './app/dashboard/doctor/profile/fees_payment_method';
import DoctorAppointments from './app/dashboard/doctor/appointments';
import DoctorAppointmentSlots from './app/dashboard/doctor/appointmentSlots';
import PatientDashboard from './app/dashboard/patient/page';
import DoctorAppointmentDetailPage from './app/dashboard/doctor/appointment_detail';
import DoctorAppointmentPrescriptionPage from './app/dashboard/doctor/appointment_prescription';
import DoctorAppointmentGeneralPrescriptionPage from './app/dashboard/doctor/appointment_prescription/general';
import DoctorAppointmentSpeechTherapyPrescriptionPage from './app/dashboard/doctor/appointment_prescription/speech_therapy';
import DoctorAppointmentDietPrescriptionPage from './app/dashboard/doctor/appointment_prescription/diet_prescription';
import DoctorAppointmentPhysiotherapyPrescriptionPage from './app/dashboard/doctor/appointment_prescription/physiotherapy';
import DoctorReports from './app/dashboard/doctor/reports';
import DoctorProfileEdit from './app/dashboard/doctor/profile/edit';

import PatientProfile from './app/dashboard/patient/profile/page';
import PatientProfileEdit from './app/dashboard/patient/profile/edit';
import PatientAppointments from './app/dashboard/patient/appointment/page';
import PatientAppointment from './app/dashboard/patient/appointment/detail';
import PatientBookAppointment from './app/dashboard/patient/appointment/book';
import Prescriptions from './app/dashboard/patient/appointment/prescriptions';
import UploadedReports from './app/dashboard/patient/appointment/uploadedReports';

import ClinicDashboard from './app/dashboard/clinic/page';
import ClinicProfile from './app/dashboard/clinic/profile/page';
import ClinicProfileEdit from './app/dashboard/clinic/profile/edit';
import ClinicAppointments from './app/dashboard/clinic/appointment/page';
import ClinicAppointment from './app/dashboard/clinic/appointment/detail';
import ClinicBookAppointment from './app/dashboard/clinic/appointment/book';
import ClinicTeamMembers from './app/dashboard/clinic/team_members';
import ClinicPatients from './app/dashboard/clinic/patients';
import HospitalDashboard from './app/dashboard/hospital/page';
import HospitalProfile from './app/dashboard/hospital/profile/page';
import HospitalProfileEdit from './app/dashboard/hospital/profile/edit';
import HospitalAppointments from './app/dashboard/hospital/appointment/page';
import HospitalAppointment from './app/dashboard/hospital/appointment/detail';
import HospitalBookAppointment from './app/dashboard/hospital/appointment/book';
import HospitalTeamMembers from './app/dashboard/hospital/team_members';
import HospitalPatients from './app/dashboard/hospital/patients';

import DoctorPrivacyPolicy from './app/miscfiles/doctor-privacypolicy';
import DoctorRefundPolicy from './app/miscfiles/doctor-refundpolicy';
import DoctorTermsAndConditions from './app/miscfiles/doctor-termsconditions';
import PatientPrivacyPolicy from './app/miscfiles/patient-privacypolicy';
import PatientRefundPolicy from './app/miscfiles/patient-refundpolicy';
import PatientTermsAndConditions from './app/miscfiles/patient-termsconditions';

import Specialization from './app/specialization/page';
import SpecializationDoctors from './app/specialization/doctors';

import NotFound from './app/404';
import ScrollToTop from './utils/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <ScrollToTop />
      <Routes>
        <Route path="/doctor-privacypolicy" element={<DoctorPrivacyPolicy />} />
        <Route path="/doctor-refundpolicy" element={<DoctorRefundPolicy />} />
        <Route path="/doctor-termsandconditions" element={<DoctorTermsAndConditions />} />
        <Route path="/patient-termsandconditions" element={<PatientTermsAndConditions />} />
        <Route path="/patient-privacypolicy" element={<PatientPrivacyPolicy />} />
        <Route path="/patient-refundpolicy" element={<PatientRefundPolicy />} />

        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/doctorlist" element={<DoctorList />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/specialization/all" element={<Specialization />} />
          <Route path="/specialization/:slug/doctors" element={<SpecializationDoctors />} />

          <Route path="/dashboard/doctor" element={<DoctorDashboard />} />
          <Route path="/dashboard/doctor/profile" element={<DoctorProfile />} />
          <Route path="/dashboard/doctor/profile/edit" element={<DoctorProfileEdit />} />
          <Route path="/dashboard/doctor/appointments" element={<DoctorAppointments />} />
          <Route path="/dashboard/doctor/appointment/:id" element={<DoctorAppointmentDetailPage />} />
          <Route path="/dashboard/doctor/appointment-prescription/:id" element={<DoctorAppointmentPrescriptionPage />} />
          <Route path="/dashboard/doctor/appointment-prescription/general/:id" element={<DoctorAppointmentGeneralPrescriptionPage />} />
          <Route path="/dashboard/doctor/appointment-prescription/speech_therapy/:id" element={<DoctorAppointmentSpeechTherapyPrescriptionPage />} />
          <Route path="/dashboard/doctor/appointment-prescription/diet_prescription/:id" element={<DoctorAppointmentDietPrescriptionPage />} />
          <Route path="/dashboard/doctor/appointment-prescription/physiotherapy/:id" element={<DoctorAppointmentPhysiotherapyPrescriptionPage />} />
          <Route path="/dashboard/doctor/appointment-slots" element={<DoctorAppointmentSlots />} />
          <Route path="/dashboard/doctor/reports" element={<DoctorReports />} />
          <Route path="/dashboard/doctor/fees-payment" element={<FeesPaymentMethod />} />

          <Route path="/dashboard/patient" element={<PatientDashboard />} />
          <Route path="/dashboard/patient/profile" element={<PatientProfile />} />
          <Route path="/dashboard/patient/profile/edit" element={<PatientProfileEdit />} />
          <Route path="/dashboard/patient/appointments" element={<PatientAppointments />} />
          <Route path="/dashboard/patient/appointment/book" element={<PatientBookAppointment />} />
          <Route path="/dashboard/patient/appointment/:id" element={<PatientAppointment />} />
          <Route path="/dashboard/patient/prescriptions" element={<Prescriptions />} />
          <Route path="/dashboard/patient/uploaded-reports" element={<UploadedReports />} />

          <Route path="/dashboard/clinic" element={<ClinicDashboard />} />
          <Route path="/dashboard/clinic/profile" element={<ClinicProfile />} />
          <Route path="/dashboard/clinic/profile/edit" element={<ClinicProfileEdit />} />
          <Route path="/dashboard/clinic/appointments" element={<ClinicAppointments />} />
          <Route path="/dashboard/clinic/appointment/:id" element={<ClinicAppointment />} />
          <Route path="/dashboard/clinic/appointment/book" element={<ClinicBookAppointment />} />
          <Route path="/dashboard/clinic/team-members" element={<ClinicTeamMembers />} />
          <Route path="/dashboard/clinic/patients" element={<ClinicPatients />} />

          <Route path="/dashboard/hospital" element={<HospitalDashboard />} />
          <Route path="/dashboard/hospital/profile" element={<HospitalProfile />} />
          <Route path="/dashboard/hospital/profile/edit" element={<HospitalProfileEdit />} />
          <Route path="/dashboard/hospital/appointments" element={<HospitalAppointments />} />
          <Route path="/dashboard/hospital/appointment/:id" element={<HospitalAppointment />} />
          <Route path="/dashboard/hospital/appointment/book" element={<HospitalBookAppointment />} />
          <Route path="/dashboard/hospital/team-members" element={<HospitalTeamMembers />} />
          <Route path="/dashboard/hospital/patients" element={<HospitalPatients />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
